/* CarGrow product gallery: counter + tap-to-open lightbox with pinch / double-tap zoom, pan, swipe and thumbnails */
(() => {
  if (window.__cargrowLightbox) return;
  window.__cargrowLightbox = true;

  const MAX_SCALE = 5;
  const DOUBLE_TAP_MS = 300;
  let overlay;
  let state = null;

  const el = (tag, className, html) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (html) node.innerHTML = html;
    return node;
  };

  const icon = {
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    reset: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>',
    hand: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-1.5a1.5 1.5 0 0 1 3 0V11m0-.5a1.5 1.5 0 0 1 3 0V15a6 6 0 0 1-6 6h-.5A5.5 5.5 0 0 1 7 17.6L4.6 13a1.5 1.5 0 0 1 2.6-1.5L9 14"/></svg>'
  };

  const largest = (img) => {
    let src = img.currentSrc || img.src || '';
    const set = img.getAttribute('srcset');
    if (set) {
      const best = set.split(',').map((part) => part.trim().split(/\s+/)).filter((part) => part[0])
        .sort((a, b) => (parseInt(b[1], 10) || 0) - (parseInt(a[1], 10) || 0))[0];
      if (best) src = best[0];
    }
    if (/[?&]width=\d+/.test(src)) src = src.replace(/([?&])width=\d+/, '$1width=2200');
    return src.startsWith('//') ? `https:${src}` : src;
  };

  const thumbSrc = (src) => (/[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=200') : src);

  const galleryItems = (gallery) => Array.from(gallery.querySelectorAll('.product__media-list > li'))
    .map((li) => {
      const img = li.querySelector('img');
      return img ? { li, src: largest(img), alt: img.alt || '' } : null;
    })
    .filter(Boolean);

  /* ---------- gallery counter + hint ---------- */
  const enhanceGallery = (gallery) => {
    if (gallery.dataset.cgEnhanced) return;
    const host = gallery.querySelector('slider-component') || gallery;
    const items = galleryItems(gallery);
    if (!items.length) return;
    gallery.dataset.cgEnhanced = 'true';

    const counter = el('span', 'cg-gallery-counter');
    const hint = el('span', 'cg-gallery-hint', `${icon.hand}<span>Atinge imaginea pentru zoom</span>`);
    hint.setAttribute('aria-hidden', 'true');
    host.append(counter, hint);

    const update = () => {
      const list = galleryItems(gallery);
      let index = list.findIndex((item) => item.li.classList.contains('is-active'));
      if (index < 0) index = 0;
      counter.textContent = `${index + 1} / ${list.length}`;
      counter.hidden = list.length < 2;
    };
    update();
    new MutationObserver(update).observe(gallery.querySelector('.product__media-list'), { attributes: true, attributeFilter: ['class'], subtree: true });
  };

  /* ---------- lightbox ---------- */
  const build = () => {
    overlay = el('div', 'cg-lb');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Galerie imagini produs');
    overlay.hidden = true;
    overlay.innerHTML = `
      <div class="cg-lb__bar">
        <span class="cg-lb__count" aria-live="polite"></span>
        <span class="cg-lb__title"></span>
        <button type="button" class="cg-lb__close" aria-label="Închide">${icon.close}</button>
      </div>
      <div class="cg-lb__stage"><img class="cg-lb__img" alt="" draggable="false"></div>
      <button type="button" class="cg-lb__nav cg-lb__nav--prev" aria-label="Imaginea anterioară">${icon.prev}</button>
      <button type="button" class="cg-lb__nav cg-lb__nav--next" aria-label="Imaginea următoare">${icon.next}</button>
      <div class="cg-lb__tools">
        <button type="button" data-cg="out" aria-label="Micșorează">${icon.minus}</button>
        <button type="button" data-cg="reset" aria-label="Resetează">${icon.reset}</button>
        <button type="button" data-cg="in" aria-label="Mărește">${icon.plus}</button>
      </div>
      <div class="cg-lb__thumbs" role="tablist"></div>
      <p class="cg-lb__hint">Ciupește sau dă dublu-tap pentru zoom · glisează pentru a schimba imaginea</p>`;
    document.body.appendChild(overlay);

    const stage = overlay.querySelector('.cg-lb__stage');
    const img = overlay.querySelector('.cg-lb__img');
    const pointers = new Map();
    let start = null;
    let lastTap = 0;
    let lastTapPoint = null;

    const view = { s: 1, x: 0, y: 0 };
    state = { stage, img, view, items: [], index: 0, opener: null };

    const apply = (animate) => {
      img.style.transition = animate ? 'transform .28s cubic-bezier(.2,.8,.2,1)' : 'none';
      img.style.transform = `translate3d(${view.x}px, ${view.y}px, 0) scale(${view.s})`;
      overlay.classList.toggle('is-zoomed', view.s > 1.02);
    };

    const clamp = () => {
      const maxX = Math.max(0, (img.offsetWidth * view.s - stage.clientWidth) / 2);
      const maxY = Math.max(0, (img.offsetHeight * view.s - stage.clientHeight) / 2);
      view.x = Math.min(maxX, Math.max(-maxX, view.x));
      view.y = Math.min(maxY, Math.max(-maxY, view.y));
    };

    const zoomAt = (nextScale, cx, cy, animate) => {
      const rect = stage.getBoundingClientRect();
      const px = cx - (rect.left + rect.width / 2);
      const py = cy - (rect.top + rect.height / 2);
      const s = Math.min(MAX_SCALE, Math.max(1, nextScale));
      const ratio = s / view.s;
      view.x = px - (px - view.x) * ratio;
      view.y = py - (py - view.y) * ratio;
      view.s = s;
      if (s === 1) { view.x = 0; view.y = 0; }
      clamp();
      apply(animate);
    };

    const reset = (animate) => { view.s = 1; view.x = 0; view.y = 0; apply(animate); };
    state.reset = reset;
    state.zoomAt = zoomAt;

    stage.addEventListener('pointerdown', (event) => {
      try { stage.setPointerCapture(event.pointerId); } catch (error) { /* synthetic or released pointer */ }
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 1) {
        start = { x: event.clientX, y: event.clientY, vx: view.x, vy: view.y, time: Date.now(), moved: false };
      } else if (pointers.size === 2) {
        const [a, b] = Array.from(pointers.values());
        start = { dist: Math.hypot(a.x - b.x, a.y - b.y), s: view.s, pinch: true };
      }
    });

    stage.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 2 && start && start.pinch) {
        const [a, b] = Array.from(pointers.values());
        const dist = Math.hypot(a.x - b.x, a.y - b.y);
        zoomAt(start.s * (dist / start.dist), (a.x + b.x) / 2, (a.y + b.y) / 2, false);
      } else if (pointers.size === 1 && start && !start.pinch) {
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) + Math.abs(dy) > 6) start.moved = true;
        if (view.s > 1.02) {
          view.x = start.vx + dx;
          view.y = start.vy + dy;
          clamp();
          apply(false);
        } else if (start.moved) {
          img.style.transition = 'none';
          img.style.transform = `translate3d(${dx * .6}px, ${Math.max(0, dy) * .5}px, 0) scale(${1 - Math.min(.12, Math.max(0, dy) / 1200)})`;
        }
      }
    });

    const finish = (event) => {
      if (!pointers.has(event.pointerId)) return;
      const wasPinch = start && start.pinch;
      pointers.delete(event.pointerId);
      if (pointers.size > 0) return;
      if (wasPinch) { if (view.s < 1.05) reset(true); start = null; return; }
      if (!start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      const elapsed = Date.now() - start.time;
      if (view.s <= 1.02) {
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.3) { reset(false); go(dx < 0 ? 1 : -1); start = null; return; }
        if (dy > 110 && Math.abs(dy) > Math.abs(dx)) { close(); start = null; return; }
        apply(true);
      }
      if (!start.moved && elapsed < 350) {
        const now = Date.now();
        const near = lastTapPoint && Math.hypot(event.clientX - lastTapPoint.x, event.clientY - lastTapPoint.y) < 40;
        if (now - lastTap < DOUBLE_TAP_MS && near) {
          zoomAt(view.s > 1.3 ? 1 : 2.6, event.clientX, event.clientY, true);
          lastTap = 0;
        } else {
          lastTap = now;
          lastTapPoint = { x: event.clientX, y: event.clientY };
        }
      }
      start = null;
    };
    stage.addEventListener('pointerup', finish);
    stage.addEventListener('pointercancel', finish);

    stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      const factor = event.deltaY < 0 ? 1.2 : 1 / 1.2;
      zoomAt(view.s * factor, event.clientX, event.clientY, false);
    }, { passive: false });

    overlay.addEventListener('click', (event) => {
      const target = event.target.closest('[data-cg], .cg-lb__close, .cg-lb__nav, .cg-lb__thumb');
      if (!target) return;
      const rect = stage.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      if (target.classList.contains('cg-lb__close')) close();
      else if (target.classList.contains('cg-lb__nav--prev')) go(-1);
      else if (target.classList.contains('cg-lb__nav--next')) go(1);
      else if (target.classList.contains('cg-lb__thumb')) show(Number(target.dataset.index));
      else if (target.dataset.cg === 'in') zoomAt(view.s * 1.5, cx, cy, true);
      else if (target.dataset.cg === 'out') zoomAt(view.s / 1.5, cx, cy, true);
      else if (target.dataset.cg === 'reset') reset(true);
    });

    document.addEventListener('keydown', (event) => {
      if (overlay.hidden) return;
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight') go(1);
      else if (event.key === 'ArrowLeft') go(-1);
      else if (event.key === '+' || event.key === '=') { const r = stage.getBoundingClientRect(); zoomAt(view.s * 1.4, r.left + r.width / 2, r.top + r.height / 2, true); }
      else if (event.key === '-') { const r = stage.getBoundingClientRect(); zoomAt(view.s / 1.4, r.left + r.width / 2, r.top + r.height / 2, true); }
      else if (event.key === 'Tab') {
        const focusables = Array.from(overlay.querySelectorAll('button')).filter((button) => !button.disabled && button.offsetParent !== null);
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });

    window.addEventListener('resize', () => { if (!overlay.hidden) { clamp(); apply(false); } });
  };

  const show = (index) => {
    const { items, img, stage } = state;
    state.index = (index + items.length) % items.length;
    const item = items[state.index];
    state.reset(false);
    overlay.classList.add('is-loading');
    img.onload = () => overlay.classList.remove('is-loading');
    img.src = item.src;
    img.alt = item.alt;
    overlay.querySelector('.cg-lb__count').textContent = `${state.index + 1} / ${items.length}`;
    overlay.classList.toggle('is-single', items.length < 2);
    overlay.querySelectorAll('.cg-lb__thumb').forEach((thumb, i) => {
      const active = i === state.index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', String(active));
      if (active) thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
    [1, -1].forEach((offset) => { const next = items[(state.index + offset + items.length) % items.length]; if (next) { const pre = new Image(); pre.src = next.src; } });
    stage.focus({ preventScroll: true });
  };

  const go = (step) => show(state.index + step);

  const open = (gallery, index) => {
    if (!overlay) build();
    const items = galleryItems(gallery);
    if (!items.length) return;
    state.items = items;
    state.opener = document.activeElement;
    overlay.querySelector('.cg-lb__title').textContent = (document.querySelector('h1') || {}).textContent ? document.querySelector('h1').textContent.trim() : '';
    const thumbs = overlay.querySelector('.cg-lb__thumbs');
    thumbs.innerHTML = '';
    items.forEach((item, i) => {
      const button = el('button', 'cg-lb__thumb');
      button.type = 'button';
      button.dataset.index = String(i);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', `Imaginea ${i + 1}`);
      const thumb = new Image();
      thumb.src = thumbSrc(item.src);
      thumb.alt = '';
      thumb.draggable = false;
      button.appendChild(thumb);
      thumbs.appendChild(button);
    });
    overlay.hidden = false;
    document.documentElement.classList.add('cg-lb-open');
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    show(index);
    overlay.querySelector('.cg-lb__close').focus({ preventScroll: true });
  };

  const close = () => {
    if (!overlay || overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('cg-lb-open');
    setTimeout(() => { overlay.hidden = true; }, 220);
    if (state.opener && state.opener.focus) state.opener.focus({ preventScroll: true });
  };

  /* Intercept the theme's default zoom modal */
  document.addEventListener('click', (event) => {
    const target = event.target.closest('media-gallery .product__media-list .product__media-item');
    if (!target) return;
    if (!event.target.closest('img, modal-opener, .product__media-toggle, .product__media-icon, .product__modal-opener, .product-media-container')) return;
    const gallery = target.closest('media-gallery');
    const items = galleryItems(gallery);
    const index = items.findIndex((item) => item.li === target);
    if (index < 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(gallery, index);
  }, true);

  const init = () => document.querySelectorAll('media-gallery').forEach(enhanceGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
